'use client'

import React, { useContext } from 'react'
import { HotelPageContext } from '@/components/hotel/HotelPageContext'

export function ProgramPrice(props: { s: string, programCode: string, s1: string }) {
  const { getProgram } = useContext(HotelPageContext)
  const program = getProgram(props.programCode)
  return <div className='mr-2 hidden text-right open:hidden sm:block'>
    <div className='whitespace-nowrap font-semibold leading-tight text-stone-900'>
      <span className='mr-1 text-sm'>{props.s}</span>
      <span className='text-2xl font-medium sm:text-3xl'>{program.price}</span>
    </div>
    {program.priceOriginal && program.priceOriginal !== program.price && (
      <div className='whitespace-nowrap text-sm leading-tight text-red-400 line-through'>
        {props.s1} {program.priceOriginal}
      </div>
    )}
  </div>
}